import {FC, useEffect} from 'react'
import {useDataLayerValue} from '../../../../DataLayer'
import {registerAuthSideEffects, unregisterAuthSideEffects} from './authDataLayerBridge'

/**
 * Registers DataLayer dispatch handlers for TokenRefresh side effects.
 * Must render inside DataLayer.
 */
const AuthSideEffectsRegistrar: FC = () => {
  const [, dispatch] = useDataLayerValue()

  useEffect(() => {
    registerAuthSideEffects({
      setPolicies: (policies: number[]) => {
        dispatch({type: 'SET_POLICIES', policies})
      },
      resetState: () => {
        dispatch({type: 'RESET_STATE'})
      },
    })

    return () => {
      unregisterAuthSideEffects()
    }
  }, [dispatch])

  return null
}

export {AuthSideEffectsRegistrar}
